import { BaseDto } from "@/shared/dtos/base-dto";

export class centros extends BaseDto {
  public agent_id: string = "";
  public installation_id: string = "";
  public tenant_id: string = "";
  public nombre: string = "";
  public descripcion: string = "";
  public direccion: string = "";
  public ciudad: string = "";
  public provincia: string = "";
  public codigo_postal: string = "";
  public pais: string = "";
  public telefono: string = "";
  public created_by_user_id: string = "";
  public updated_by_user_id: string = "";
  public created_at_utc: Date | null = null;
  public updated_at_utc: Date | null = null;
  public is_enabled: boolean = true;
  public is_deleted: boolean = false;

  constructor(data?: any) {
    super();
    if (!data) {
      return;
    }

    this.copy(data);

    if (data.created_at_utc) {
      this.created_at_utc = new Date(data.created_at_utc);
    }
    if (data.updated_at_utc) {
      this.updated_at_utc = new Date(data.updated_at_utc);
    }
  }
}
